import type { ReactNode } from 'react';

import { Flex, VFlex } from '@/components/base';

import DashboardCardStyles from '../styles/DashboardCardStyles';

const { DashboardCardHeader } = DashboardCardStyles;

type DashboardCardContentHeaderProps = {
  title: ReactNode;
  titleExtra?: ReactNode;
  subtitle?: ReactNode;
  rightAction?: ReactNode;
  onTitleClick?: () => void;
  headerAlign?: 'start' | 'center';
  rightActionClassName?: string;
};

const DashboardCardContentHeader = ({
  title,
  titleExtra,
  subtitle,
  rightAction,
  onTitleClick,
  headerAlign,
  rightActionClassName,
}: DashboardCardContentHeaderProps) => {
  return (
    <DashboardCardHeader
      j="space-between"
      a={headerAlign || (subtitle ? 'start' : 'center')}
    >
      <VFlex g={subtitle ? 4 : 8} f={1} className="min-w-0">
        <Flex
          g={8}
          a="center"
          className={`min-w-0 ${onTitleClick ? 'cursor-pointer' : ''}`}
          onClick={onTitleClick}
        >
          {title}
          {titleExtra}
        </Flex>
        {subtitle}
      </VFlex>
      <Flex a="center" g={8} className={rightActionClassName}>
        {rightAction}
      </Flex>
    </DashboardCardHeader>
  );
};

export default DashboardCardContentHeader;
